var map = {
	"./stream-type-combained-ico.svg": "./src/assets/icons/stream-type-combained-ico.svg",
	"./stream-type-ipcam-ico.svg": "./src/assets/icons/stream-type-ipcam-ico.svg",
	"./stream-type-live-ico.svg": "./src/assets/icons/stream-type-live-ico.svg",
	"./stream-type-restream-ico.svg": "./src/assets/icons/stream-type-restream-ico.svg",
	"./stream-type-scheduled-ico.svg": "./src/assets/icons/stream-type-scheduled-ico.svg",
	"./stream-type-subsecond-ico.svg": "./src/assets/icons/stream-type-subsecond-ico.svg",
	"./stream-type-transcoder-ico.svg": "./src/assets/icons/stream-type-transcoder-ico.svg",
	"./stream-type-tvplayout-ico.svg": "./src/assets/icons/stream-type-tvplayout-ico.svg",
	"./stream-type-vod-ico.svg": "./src/assets/icons/stream-type-vod-ico.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/stream\\-type\\-.*\\-ico\\.svg$";